/* eslint-disable no-restricted-syntax */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Loader } from '@playbookux/playbook-web-core';
import { ConnectButtonContainer } from './styles';
import { GET_PATHFIX_INTEGRATION_PARAMS } from './graphql';

export const PathfixConnectButton = (props) => {
  const {
    endUserId,
    descriptions,
    onConnect,
    onDisconnect,
  } = props;

  const oauthExtensionRef = useRef(null);

  const {
    data: pathfixIntegrationData,
    loading: pathfixIntegrationLoading,
    error: pathfixIntegrationError,
  } = useQuery(GET_PATHFIX_INTEGRATION_PARAMS);

  const pathfixPublicKey = pathfixIntegrationData?.pathfixOauthIntegrationParams?.publicKey;

  useEffect(() => {
    // if script already exists, remove it
    const existingScript = document.getElementById('pinc.helper');
    if (!existingScript && pathfixPublicKey) {
      const script = document.createElement('script');
      script.id = 'pinc.helper';
      script.src = 'https://labs.pathfix.com/helper.js';
      script.setAttribute('modules', 'pinc.oauth.min');
      script.setAttribute('data-public-key', pathfixPublicKey);
      script.setAttribute('data-user-id', endUserId);
      document.body.appendChild(script);
    }

    const observer = new MutationObserver((mutationsList) => {
      // once the contents of the div are loaded
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const oauthExtensionDiv = document.getElementById('pathfix-oauth-extension');
          const oauthExtensionDivChildren = oauthExtensionDiv.children;
          // customizing the oauth extension
          for (const child of oauthExtensionDivChildren) {
            if (child.innerText === 'Connected Apps') {
              child.remove();
            }
          }

          // find a button in the oauthExtensionDiv children
          const oauthExtensionDivButtonConnect = oauthExtensionDiv.getElementsByTagName('button')[0];
          const oauthExtensionDivButtonDisconnect = oauthExtensionDiv.getElementsByTagName('button')[1];

          // if the button exists and is a connect button, change add onCOnnect to onclick
          if (oauthExtensionDivButtonConnect) {
            oauthExtensionDivButtonConnect.addEventListener('click', onConnect);
          }

          if (oauthExtensionDivButtonDisconnect) {
            oauthExtensionDivButtonDisconnect.addEventListener('click', onDisconnect);
          }

          // replace the mt-1 provider-description text-sm div with a ul and the value as li
          const providerDescriptionDiv = document.getElementsByClassName('mt-1 provider-description text-sm')[0];

          if (providerDescriptionDiv) {
            const providerDescriptionUl = document.createElement('ul');
            providerDescriptionUl.className = 'provider-description-ul';

            // for each description append it as a li to ul
            for (const description of descriptions) {
              const providerDescriptionLi = document.createElement('li');
              providerDescriptionLi.className = 'provider-li';
              providerDescriptionLi.innerText = description;
              providerDescriptionUl.appendChild(providerDescriptionLi);
            }

            providerDescriptionDiv.replaceWith(providerDescriptionUl);
          }

          // get the style tag
          const oauthExtensionStyle = document.getElementById('pathfix-oauth-extension').getElementsByTagName('style')[0];
          // change p-name-group to be width: 100%
          if (oauthExtensionStyle) oauthExtensionStyle.innerHTML += '.p-name-group { width: 100%; }';
          // change p-name-group to be width: 100%
        }
      }
    });

    if (!pathfixIntegrationLoading && !pathfixIntegrationError) {
      observer.observe(oauthExtensionRef.current, { childList: true });
    }

    return () => {
      observer.disconnect();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathfixPublicKey]);

  if (pathfixIntegrationLoading) return <Loader data-loader="connect-button-loader" />;

  return (
    <ConnectButtonContainer>
      <div
        id="pathfix-oauth-extension"
        ref={oauthExtensionRef}
        data-oauth-ui="list-panel"
        data-oauth-ui-switches="statusOn,disconnect"
        data-oauth-icon-size="Medium"
      />
    </ConnectButtonContainer>
  );
};

PathfixConnectButton.propTypes = {
  endUserId: PropTypes.string.isRequired,
  descriptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  onConnect: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
};
